import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SamwebBrick } from '../../samweb-brick.decorator';
import { BrickCategory } from '../../../../samwebDescription/samweb/brickCategoryType';
import { BasicBrickComponent } from '../../basic-brick-component';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';

@Component({
   selector: 'samweb-brick-not-allowed-brick',
   templateUrl: './brick-not-allowed-brick.component.html',
   styleUrls: ['./brick-not-allowed-brick.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
})
@SamwebBrick({
   brickDefinitionId: BrickNotAllowedBrickComponent.BrickId,
   brickTitleTranslationKey: 'brick.brick-management.brick-not-allowed',
   brickDescriptionTranslationKey: null,
   brickIcon: WellKnownIconsEnum.NOT_ALLOWED.icon,
   minColWidth: 10,
   minRowHeight: 10,
   brickCategory: BrickCategory.DEBUG,
   disableAddingByUser: true,
   disallowBrickSettings: true,
})
export class BrickNotAllowedBrickComponent extends BasicBrickComponent {
   public static BrickId = 'brickNotAllowed';
   public readonly icon = WellKnownIconsEnum.NOT_ALLOWED.icon;

   constructor() {
      super();
   }
}
